import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { routeNames } from 'src/modules/core/constants/routeNames'
import { Button, FormattedText, Modal, Typography } from 'src/modules/core/components'
import { useUpdateUserPreferences, useUserPreferences } from 'src/modules/preferences/hooks/use-user-preferences'
import classes from './set-and-forget-promo-modal.module.scss'

const OTHER_SETTINGS_TAB = 'other-settings'

export type SetAndForgetPromoModalProps = {
  open: boolean
  onClose: () => void
}

export function SetAndForgetPromoModal({ open, onClose }: SetAndForgetPromoModalProps) {
  const preferencesQuery = useUserPreferences()
  const updatePreferences = useUpdateUserPreferences()

  const handleEnable = useCallback(async () => {
    if (!preferencesQuery.data) {
      return
    }

    try {
      await updatePreferences.mutateAsync({
        google_calendar_settings_customized: preferencesQuery.data.user_preferences.google_calendar_settings_customized,
        auto_activate_when_clear: true,
      })
      onClose()
    } catch {
      /* errors surface via global handlers */
    }
  }, [onClose, preferencesQuery.data, updatePreferences])

  if (!open) {
    return null
  }

  const settingsPath = `${routeNames.settings.path}?tab=${OTHER_SETTINGS_TAB}`

  return (
    <Modal
      variant="primary"
      closeOnBackdropClick={false}
      onClose={onClose}
      title={
        <Typography variant="h3" className={classes.modalTitle}>
          <FormattedText id="setAndForgetPromo.title" />
        </Typography>
      }
    >
      <div className={classes.root}>
        <Typography variant="body">
          <FormattedText id="setAndForgetPromo.body" />
        </Typography>
        <div className={classes.actions}>
          <Button onClick={() => void handleEnable()} isLoading={updatePreferences.isLoading} widthType="content">
            <FormattedText id="setAndForgetPromo.enableCta" />
          </Button>
          <Link to={settingsPath} className={classes.settingsLink} onClick={onClose}>
            <FormattedText id="setAndForgetPromo.settingsLink" />
          </Link>
        </div>
      </div>
    </Modal>
  )
}
